export const API_URL = 'https://eventfork.com/api';
export const API_BASE_URL = 'https://eventfork.com/api'
export const EVENTS_ENDPOINT = '/api/event';
// export const API_URL = 'http://localhost:5000/api';
// export const API_BASE_URL = 'http://localhost:5000/api';
export const TIMEOUT = 10000;
